import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SessionDayTimeRecord {
  date: string;
  startTime: string;
  endTime: string;
}

interface EventSessionDayState {
  sessionDays: Record<string, Record<string, SessionDayTimeRecord>>;
}

const initialState: EventSessionDayState = {
  sessionDays: {},
};

const eventSessionDaySlice = createSlice({
  name: "eventSessionDay",
  initialState,
  reducers: {
    setSessionDayTime(
      state,
      action: PayloadAction<{
        formId: string;
        date: string;
        startTime: string;
        endTime: string;
      }>,
    ) {
      const { formId, date, startTime, endTime } = action.payload;

      if (!state.sessionDays[formId]) {
        state.sessionDays[formId] = {};
      }

      state.sessionDays[formId][date] = {
        date,
        startTime,
        endTime,
      };
    },

    setSessionDayTimes(
      state,
      action: PayloadAction<{
        formId: string;
        times: SessionDayTimeRecord[];
      }>,
    ) {
      const { formId, times } = action.payload;

      if (!state.sessionDays[formId]) {
        state.sessionDays[formId] = {};
      }

      times.forEach((timeRecord) => {
        state.sessionDays[formId][timeRecord.date] = timeRecord;
      });
    },

    clearSessionDays(state, action: PayloadAction<{ formId: string }>) {
      const { formId } = action.payload;
      delete state.sessionDays[formId];
    },
  },
});

export const { setSessionDayTime, setSessionDayTimes, clearSessionDays } =
  eventSessionDaySlice.actions;

export default eventSessionDaySlice.reducer;

export const selectSessionDays = (
  state: { eventSessionDay: EventSessionDayState },
  formId: string,
) => state.eventSessionDay.sessionDays[formId] || {};
